module.exports = __webpack_public_path__ + "img/jet.98b80e56.png";